import React, { useEffect } from 'react'
import Calendar from '@assets/img/reservation/calendar.svg'
import ParkingPink from '@assets/img/reservation/parking-pink.svg'
import ParkingGray from '@assets/img/reservation/parking-gray.svg'
import Car from '@assets/img/reservation/car.svg'
import CheckboxBasePink from '@assets/img/reservation/checkbox-base-pink.svg'
import CheckboxBaseGray from '@assets/img/reservation/checkbox-base-gray.svg'
import classNames from 'classnames'
import { useReservationContext } from './ReservationContext'

const ParkingBox = ({ selected, parkingOffer }) => {
    const {
        t,
        offer,
        selectedParkingOffer,
        setSelectedParkingOffer,
    } = useReservationContext()

    return (
        <div
            className={classNames('trip-reservation__parking-box', {
                'trip-reservation__parking-box--selected': parkingOffer === selectedParkingOffer,
            })}
            onClick={() => {
                if (parkingOffer === selectedParkingOffer) {
                    setSelectedParkingOffer(null)
                } else {
                    setSelectedParkingOffer(parkingOffer)
                }
            }}
        >
            <div className="trip-reservation__parking-box-left">
                <div className="trip-reservation__parking-box-first">
                    <img
                        src={parkingOffer === selectedParkingOffer ? ParkingPink : ParkingGray}
                        alt=""
                        className="trip-reservation__parking-box-parking-icon"
                    />
                    {selected ? (
                        <img
                            src={Car}
                            alt="car"
                            className="trip-reservation__parking-box-car-icon trip-reservation__parking-box-car-icon-mobile"
                        />
                    ) : null}
                </div>
                <div className="trip-reservation__parking-box-checkbox">
                    <img src={parkingOffer === selectedParkingOffer ? CheckboxBasePink : CheckboxBaseGray} alt="car" />
                    {selected ? t('parking-choice') : t('parking-check-position')}
                </div>
                <div className="trip-reservation__parking-box-price-wrapper">
                    <div className="trip-reservation__parking-box-price">{parkingOffer ? parkingOffer.price_online : '-'} PLN</div>
                    <div className="trip-reservation__parking-box-for">{ t('parking-price-for') }</div>
                </div>
                {selected ? (
                    <img
                        src={Car}
                        alt="car"
                        className="trip-reservation__parking-box-car-icon trip-reservation__parking-box-car-icon-desktop"
                    />
                ) : null}
            </div>
            <div className="trip-reservation__parking-box-right">
                <div className="trip-reservation__parking-box-title">
                    {parkingOffer && parkingOffer.parking ? parkingOffer.parking.name : '-'} | {parkingOffer && parkingOffer.parking ? parkingOffer.parking.address: '-'}
                </div>
                <hr className="trip-reservation__parking-box-divider"></hr>
                <div className="trip-reservation__parking-box-dates">
                    <div className="trip-reservation__parking-box-date-row">
                        <img src={Calendar} alt="calendar" />
                        {t('parking-date-from')}
                        <div className="trip-reservation__parking-box-date">{offer && offer.departureDate ? offer.departureDate : '-'}</div>
                    </div>
                    <div className="trip-reservation__parking-box-date-row">
                        <img src={Calendar} alt="calendar" />
                        {t('parking-date-to')}
                        <div className="trip-reservation__parking-box-date">{offer && offer.returnDate ? offer.returnDate : '-'}</div>
                    </div>
                    {parkingOffer && parkingOffer.parking && parkingOffer.parking.transfer_distance && (
                        <div className="trip-reservation__parking-box-date-row">
                            <img src={Calendar} alt="calendar" />
                            {t('parking-distance-for-airport')}
                            <div className="trip-reservation__parking-box-date">{parkingOffer && parkingOffer.parking ? parkingOffer.parking.transfer_distance : '-'} km</div>
                        </div>
                    )}
                    {parkingOffer && parkingOffer.parking && parkingOffer.parking.transfer_time && (
                        <div className="trip-reservation__parking-box-date-row">
                            <img src={Calendar} alt="calendar" />
                            {t('parking-transfer-time')}
                            <div className="trip-reservation__parking-box-date">{parkingOffer && parkingOffer.parking ? parkingOffer.parking.transfer_time : '-'} min.</div>
                        </div>
                    )}
                    {parkingOffer && parkingOffer.parking && parkingOffer.parking.freeTransfer && (
                        <div className="trip-reservation__parking-box-date-row">
                            <img src={Calendar} alt="calendar" />
                            <div className="trip-reservation__parking-box-date">{t('parking-free transfer')}</div>
                        </div>
                    )}
                </div>
                {/*
                <div className="trip-reservation__parking-box-change-date">{t('parking-change-date')}</div>
                */}
            </div>
        </div>
    )
}

export default ParkingBox
